// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transfer-operator-tab-container {
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid rgb(161, 161, 161);
}

.transfer-operator_tab {
    width: 30%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
}

.transfer-operator_tab.selected {
    border-bottom: 1px solid;
    font-weight: bold;
}

.transfer-tier-row {
    text-align: left;
    padding: .3rem;
    width: 98%;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
}

.transfer-tier-selected-row {
    float: right;
}

.transfer-invite-dialog__body__bot-container {
    max-height: 32.5rem;
    overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/transfer-chat/TransferChat.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,UAAU;IACV,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".transfer-operator-tab-container {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    border-bottom: 1px solid rgb(161, 161, 161);\r\n}\r\n\r\n.transfer-operator_tab {\r\n    width: 30%;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.transfer-operator_tab.selected {\r\n    border-bottom: 1px solid;\r\n    font-weight: bold;\r\n}\r\n\r\n.transfer-tier-row {\r\n    text-align: left;\r\n    padding: .3rem;\r\n    width: 98%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n.transfer-tier-selected-row {\r\n    float: right;\r\n}\r\n\r\n.transfer-invite-dialog__body__bot-container {\r\n    max-height: 32.5rem;\r\n    overflow-y: auto;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
